import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { removeToken } from '../../services/TokenStorage';
import { doLogout } from '../../services/AuthService';
import { processError } from '../../services/ServiceUtils';
import SideBarItem from './SideBarItem';
import { getEnvironment } from '../../services/EnvironmentStorage';
import { getPathHomePage } from '../../utils/HomePageUtils';
import SystemHealthIndicator from './SystemHealthIndicator';
import ToastHistoryModal from '../Toast/ToastHistoryModal';
import SessionRenewalBanner from './SessionRenewalBanner';

function SideBar() {

    const history = useHistory();

    const [environment, setEnvironment] = useState('');

    function capitalizeFirstLetter(value) {
        if (!value) return value;
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }

    useEffect(() => {
        const environmentValue = capitalizeFirstLetter(getEnvironment());
        setEnvironment(`Ambiente: ${environmentValue}`);
    }, []);

    const ttSettings = useRef(null);

    useEffect(() => {
        if (!window.bootstrap) return;
        const el = document.getElementById('sidebar-tt-settings');
        if (!el) return;
        ttSettings.current = new window.bootstrap.Tooltip(el, {
            placement: 'right', trigger: 'hover',
            title: 'Configurações globais do sistema: corretora padrão, IA padrão, símbolos e logs'
        });
        el.addEventListener('click', () => ttSettings.current && ttSettings.current.hide());
        return () => { if (ttSettings.current) { ttSettings.current.dispose(); ttSettings.current = null; } };
    }, []);

    function clearAndRedirect() {
        removeToken();
        history.push('/');
    }

    function onLogoutClick(event) {
        doLogout()
            .then(response => clearAndRedirect())
            .catch(err => {
                processError(err);
                clearAndRedirect();
            })
    }

    return (
        <React.Fragment>
            <nav id="sidebarMenu" className="sidebar d-lg-block bg-gray-800 text-white collapse" datasimplebar="true">
                <div className="sidebar-inner px-4 pt-3">
                    <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
                        <div className="collapse-close d-md-none">
                            <a href="#sidebarMenu" data-bs-toggle="collapse"
                                data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="true"
                                aria-label="Toggle navigation">
                                <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </a>
                        </div>
                    </div>
                    <ul className="nav flex-column pt-3 pt-md-0">

                        <li className="nav-item mb-3">
                            <span className="mt-1 ms-1 sidebar-text text-warning">{environment}</span>
                        </li>

                        <li className="nav-item">
                            <Link to={getPathHomePage()} className="nav-link d-flex align-items-center">
                                <span className="sidebar-icon">
                                    <img src="/img/favicon/favicon-32x32.png" height="32" width="32" alt="Beholder Logo" />
                                </span>
                                <span className="mt-1 ms-1 sidebar-text">Hydra Menu</span>
                            </Link>
                        </li>

                        <SideBarItem to="/dashboard" text="Dashboard"
                            tooltip="Visão geral do sistema: usuários ativos, ordens recentes e status dos serviços">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
                                <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
                            </svg>
                        </SideBarItem>

                        <SideBarItem to="/users" text="Usuários"
                            tooltip="Gerencie os traders cadastrados: crie contas, altere planos e acompanhe o uso">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" /></svg>
                        </SideBarItem>

                        <SideBarItem to="/limits" text="Limites"
                            tooltip="Define planos de uso: quantidade máxima de monitores, automações e ordens por usuário">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" /><path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" /></svg>
                        </SideBarItem>

                        <li className="nav-item">
                            <span
                                className="nav-link collapsed d-flex justify-content-between align-items-center"
                                id="sidebar-tt-settings"
                                data-bs-toggle="collapse"
                                data-bs-target="#submenu-settings"
                            >
                                <span>
                                    <span className="sidebar-icon">
                                        <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd"
                                                d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                                                clipRule="evenodd"></path>
                                        </svg>
                                    </span>
                                    <span className="sidebar-text">Configurações</span>
                                </span>
                                <span className="link-arrow">
                                    <svg className="icon icon-sm" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                                    </svg>
                                </span>
                            </span>
                            <div className="multi-level collapse" role="list" id="submenu-settings">
                                <ul className="flex-column nav">
                                    <SideBarItem to="/settings" text="Sistema"
                                        tooltip="Configurações globais: alertas (e-mail, SMS, Telegram), corretora padrão e IA padrão" />
                                    <SideBarItem to="/authentication" text="Autenticação"
                                        tooltip="Gerenciar sessões ativas, histórico de acessos e regras de senha" />
                                    <SideBarItem to="/symbols" text="Símbolos"
                                        tooltip="Sincronize e gerencie os pares de negociação disponíveis para os traders" />
                                    <SideBarItem to="/strategy-templates" text="Templates de Estratégia"
                                        tooltip="Ajuste os valores e presets dos templates de estratégia (sem deploy); a lógica fica no código" />
                                    <SideBarItem to="/logs" text="Logs"
                                        tooltip="Registros de atividade do sistema: erros, ordens executadas e eventos de automação" />
                                </ul>
                            </div>
                        </li>

                        <li role="separator" className="dropdown-divider mt-4 mb-3 border-gray-700"></li>

                        <li className='nav-item'>
                            <button
                                className='nav-link w-100 text-start border-0 bg-transparent d-flex align-items-center'
                                data-bs-toggle='modal'
                                data-bs-target='#modalToastHistory'
                            >
                                <span className='sidebar-icon'>
                                    <svg className='icon icon-xs me-2' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
                                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' />
                                    </svg>
                                </span>
                                <span className='sidebar-text'>Notificações</span>
                            </button>
                        </li>

                        <SideBarItem to="/" text="Sair" onClick={onLogoutClick}
                            tooltip="Encerrar sessão administrativa e voltar para a tela de login">
                            <svg className="icon icon-xs me-2" fill="none" stroke="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                </path>
                            </svg>
                        </SideBarItem>

                        <SessionRenewalBanner />
                        <SystemHealthIndicator />

                    </ul>
                </div>
            </nav>
            <ToastHistoryModal />
        </React.Fragment>
    );
}

export default SideBar;
